<template>
  <b-modal v-model="showModal" size="xl" @hidden="cancelar" button-size="md" hide-footer :title="prefix + title">
    <b-card no-body>
      <b-card-body>
        <b-card bg-variant="light">
          <b-form-row @keyup.enter="load" class="align-items-center">
            <b-col lg="2" sm="12" class="text-left">
              <lg-form-const-select label="Situação:" v-model="form.situacao" :options="options"
                @change="load"></lg-form-const-select>

            </b-col>

            <b-col lg="6" cols="12" class="text-left">
              <lg-form-input description="" v-model="form.nome" label="Nome" />
            </b-col>

            <b-col lg="3" sm="1" class="ml-4 d-flex justify-content-end align-items-center">
              <b-button title="Localizar" class="ml-3 mr-2 my-2" size="sm" style="height: 20px" pill variant="primary"
                @click="load">
                <div class="btn-size-alinhamento">
                  <b-icon icon="search" />
                </div>
              </b-button>

              <b-button title="Adicionar novo..." v-if="podeEditar && temPrivilegioIncluirFoto()" class="mr-2 my-2" size="sm" style="height: 20px"
                pill variant="primary" @click="abrirModalFoto">
                <div class="btn-size-alinhamento">
                  <b-icon icon="plus" /> &nbsp;
                </div>
              </b-button>



            </b-col>
          </b-form-row>
          <b-table responsive class="mt-2" small bold-rows :busy="this.busy" :items="this.records"
            :fields="this.tableFields" @row-clicked="handleRowClicked" @row-dblclicked="handleRowClicked" show-empty>
            <template #empty>
              <p>Nenhum registro encontrado</p>
            </template>

            <template #table-busy>
              <div class="text-center text-primary my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong> Carregando...</strong>
              </div>
            </template>
            <template v-slot:cell(nome)="{ item }">
              <span style="color: blue; text-decoration: underline; cursor: pointer">{{ item.nome }}</span>
            </template>

            <template v-slot:cell(action)="row">
              <b-button v-if="podeEditar" :disabled="temPrivilegioEditarFoto()" :id="row.index + 'edit-button-foto-produto'" class="my-2" size="sm" pill variant="primary"
                @click="abrirModalFoto(row.item)">
                <b-icon icon="pencil-square" />
                <b-tooltip :target="row.index + 'edit-button-foto-produto'" title="Editar..."></b-tooltip>
              </b-button>
            </template>

            <template v-slot:cell(situacao)="row">
              <div v-if="podeEditar" :id="row.index + 'switchModalFotoProduto'">
                <b-form-checkbox v-model="row.item.situacao" @change="alteraSituacao(row.item)" name="check-button"
                  switch size="lg" :value="1" :unchecked-value="0" />
                <b-tooltip :target="row.index + 'switchModalFotoProduto'" title="Ativar/Desativar..."></b-tooltip>
              </div>

            </template>


          </b-table>
        </b-card>
      </b-card-body>
      <Modal-Exibe-Foto-Produto :imageBytes="imageBytes" @close="closeModal" v-if="exibirFotoModal"
        :title="prefix + title" />

      <FotoProdutoAdicionar :prefix="prefix + title + ' > '" :idFoto="idFoto" :id="id" v-if="mostrarModalFoto"
        @fecharModal="fechar">
      </FotoProdutoAdicionar>

    </b-card>
  </b-modal>
</template>
<script>
import LgFormConstSelect from "../Form/LgFormConstSelect.vue"
import LgFormInput from "../Form/LgFormInput.vue"
import { ListResourceMixin } from "@/core/mixins/resource"
import ConfirmMixin from "@/core/mixins/confirm"
import ModalExibeFotoProduto from "./ModalExibeFotoProduto.vue"
import ResourceService from "@/core/api/ResourceService";
import FotoProdutoAdicionar from "@/modules/almoxarifados/foto-produto/FotoProdutoAdicionar.vue"
import FotoProdutoService from "@/core/api/FotoProdutoService"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"


export default {
  components: { LgFormConstSelect, LgFormInput, ModalExibeFotoProduto, FotoProdutoAdicionar },

  mixins: [ListResourceMixin, ConfirmMixin],
  props: {
    id: Number,
    ignoreInitialLoad: Boolean,
    title: { type: String, default: " > Foto do Produto" },
    prefix: { type: String, default: "" },
    podeEditar: {
      type: Boolean,
      default: true,
    }
  },

  data() {
    return {
      filtro: {},
      idFoto: null,
      mostrarModalFoto: false,
      busy: true,
      showModal: true,
      exibirFotoModal: false,
      imageBytes: "",
      records: [],
      form: {
        nome: "",
        situacao: 1,
      },
      options: [
        { text: "Todos", value: null },
        { text: "Ativo", value: 1 },
        { text: "Inativo", value: 0 },
      ],
    }
  },

  beforeMount() {
    this.$service = new ResourceService(`/api/foto`);
    this.$fotoProdutoService = new FotoProdutoService();

  },

  mounted() {
    this.load()
  },

  computed: {
    tableFields() {
      return [{ key: "nome", label: "Nome" }, { key: "action", label: " ", tdClass:"w-1" }, { key: "situacao", label: " ", tdClass:"w-1" }]
    },
  },

  methods: {

    temPrivilegioIncluirFoto() {
      return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_INCLUIR_FOTO_PRODUTO);

    },

    temPrivilegioEditarFoto() {
      return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_EDITAR_FOTO_PRODUTO);

    },


    
    

    async alteraSituacao(item) {
      let response = await this.$confirm(
        "Deseja " + (item.situacao === 1 ? "ativar" : "desativar") + " a Foto do Produto?",
        item.nome.toUpperCase()
      )
      if (response == true) {
        this.confirmarAlteracaoSituacao(item)
      } else {
        item.situacao = item.situacao === 1 ? 0 : 1
      }
    },


    async confirmarAlteracaoSituacao(item) {
      const { status } = await this.$fotoProdutoService.alteraSituacao(item);
      if (status == 200) {
        this.$notify({
          type: "success",
          message: `Registro ${item.situacao ? "Ativado" : "Desativado"
            } com sucesso!`,
        })
      } else {
        this.$notify({
          type: "danger",
          message: `Erro ao ${item.situacao ? "Ativar" : "Desativar"
            } o registro!`,
        })
      }
    },

    abrirModalFoto(item) {
      if (item)
        this.idFoto = item.codFotoProduto;

      this.mostrarModalFoto = true;
    },
    fechar() {
      this.idFoto = null;
      this.mostrarModalFoto = false;
      this.load();
    },
    cancelar() {
      this.$emit("close")
    },

    async load() {
      this.filtro = {};
      if (this.form.situacao !== null) {
        this.filtro.situacao = this.form.situacao
      }

      if (this.form.nome !== "") {
        this.filtro.nome = this.form.nome
      }


      this.filtro.idProduto = this.id;

      this.busy = true;
      await this.$loadResource({
        size: 10000,
        page: this.page,
        params: this.filtro,
      });




    },

    closeModal() {
      this.exibirFotoModal = false
    },

    handleRowClicked(item) {
      this.imageBytes = item.arquivo
      this.exibirFotoModal = true
    },
  },
}
</script>
